// extracted by mini-css-extract-plugin
export default {"disable-scroll":"creditdetails_disable-scroll__EhJ1D","credit-details":"creditdetails_credit-details__8WCej"};